var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4086 13.3028L10.3324 7.31182H22.6943C23.8467 7.31182 24.7895 8.24145 24.7895 9.37767V17.2176H20.372L19.9495 16.7941L18.7133 15.5752H22.6943V11.4435H16.4086V13.3028ZM27 26.3797L25.6695 27.6915L24.2657 26.2867C24.2664 26.421 17.6762 19.8102 17.6762 19.8102L15.4762 17.6411L8.02762 17.6411V21.7728H14.7109L16.4092 23.8387H8.02762C6.87524 23.8387 5.93238 22.909 5.93238 21.7728V9.37767C5.93238 9.04714 6.01619 8.73726 6.16286 8.45837L5 7.31182L6.34095 6L27 26.3797ZM13.381 15.5752L9.19048 11.4435H8.02762V15.5752H13.381Z",
    fill: "#EF4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5046 26.9375L20.3903 28.7657C20.9142 29.2822 21.6475 28.869 21.6475 28.2596L21.6473 25.3882L15.4556 19.3183C15.31 19.6442 15.3223 20.0321 15.5713 20.3267L18.5046 23.8387V26.9375Z",
    fill: "#EF4444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0308 20.9852L24.5802 20.3267C25.104 19.6037 24.5802 18.674 23.7421 18.674H21.6467L24.0308 20.9852Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFilter);
export default __webpack_public_path__ + "static/media/clearFilter.2e4b2f1a4c141c2c0ff6ec0a662f0c98.svg";
export { ForwardRef as ReactComponent };